// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad4780e5","455":"91d8a413","488":"4919476e","977":"acc5f5cd"}[chunkId] + ".chunk.js";
};